import type { NullableType } from '@/types'
import type { PayloadAction } from '@reduxjs/toolkit'
import { createSlice } from '@reduxjs/toolkit'
import type { DriverTask, DriverTasksState } from './types'

const initialState: DriverTasksState = {
  items: [],
  completedTask: null,
}

export const driverTasksSlice = createSlice({
  name: 'driverTasks',
  initialState,
  reducers: {
    setDriverTask: (state, { payload }: PayloadAction<DriverTask>) => {
      state.items.push(payload)
    },
    removeDriverTask: (state, { payload }: PayloadAction<number[]>) => {
      state.items = state.items.filter((item) => !payload.includes(item.id))
    },
    setCompletedTask: (
      state,
      { payload }: PayloadAction<NullableType<Partial<DriverTask>>>
    ) => {
      state.completedTask = payload
    },
  },
})

export const { setDriverTask, removeDriverTask, setCompletedTask } =
  driverTasksSlice.actions
